import * as type from '../../../actions/index.types';

const initialState = {
    complaintsListLoading: false,
    complaintsListData: null,
    complaintsPagination: null,

    complaintDetailsLoading: false,
    complaintDetailsData: null,

    createComplaintLoading: false,
    updateComplaintLoading: false,
    deleteComplaintLoading: false,

    statusChangeLoading: false,
    assignLoading: false,
    commentLoading: false,
    attachmentLoading: false,

    complaintEnumsLoading: false,
    complaintEnumsData: null,

    statsLoading: false,
    statsData: null,

    categoriesLoading: false,
    categoriesData: null,

    // Webmaster multi-society list — separate slice so single-society and
    // cross-society consumers don't clobber each other.
    categoriesMultiLoading: false,
    categoriesMultiData: null,
    categoryMutationLoading: false,

    employeeComplaintsLoading: false,
    employeeComplaintsData: null,

    ratingLoading: false,

    auditLogLoading: false,
    auditLogData: null,

    error: null,
};

export function ComplaintReducer(state = initialState, action) {
    switch (action.type) {
        case type.SOCIETY_GET_COMPLAINTS_LIST:
            return { ...state, complaintsListLoading: true, error: null };
        case type.SOCIETY_GET_COMPLAINTS_LIST_SUCCESS: {
            const meta = action.payload?.pagination;
            const fallbackCount = action.payload?.count ?? action.payload?.total ?? 0;
            return {
                ...state,
                complaintsListLoading: false,
                complaintsListData: action.payload?.rows || action.payload?.data || action.payload || [],
                complaintsPagination: meta || { total: fallbackCount, totalPages: Math.ceil(fallbackCount / 10) },
                error: null,
            };
        }
        case type.SOCIETY_GET_COMPLAINTS_LIST_FAILURE:
            return { ...state, complaintsListLoading: false, error: action?.message };

        case type.SOCIETY_GET_COMPLAINT_DETAILS:
            return { ...state, complaintDetailsLoading: true, error: null };
        case type.SOCIETY_GET_COMPLAINT_DETAILS_SUCCESS:
            return { ...state, complaintDetailsLoading: false, complaintDetailsData: action.payload, error: null };
        case type.SOCIETY_GET_COMPLAINT_DETAILS_FAILURE:
            return { ...state, complaintDetailsLoading: false, error: action?.message };

        case type.SOCIETY_CREATE_COMPLAINT:
            return { ...state, createComplaintLoading: true, error: null };
        case type.SOCIETY_CREATE_COMPLAINT_SUCCESS:
            return { ...state, createComplaintLoading: false, error: null };
        case type.SOCIETY_CREATE_COMPLAINT_FAILURE:
            return { ...state, createComplaintLoading: false, error: action?.message };

        case type.SOCIETY_UPDATE_COMPLAINT:
            return { ...state, updateComplaintLoading: true, error: null };
        case type.SOCIETY_UPDATE_COMPLAINT_SUCCESS:
            return { ...state, updateComplaintLoading: false, error: null };
        case type.SOCIETY_UPDATE_COMPLAINT_FAILURE:
            return { ...state, updateComplaintLoading: false, error: action?.message };

        case type.SOCIETY_DELETE_COMPLAINT:
            return { ...state, deleteComplaintLoading: true, error: null };
        case type.SOCIETY_DELETE_COMPLAINT_SUCCESS:
            return { ...state, deleteComplaintLoading: false, error: null };
        case type.SOCIETY_DELETE_COMPLAINT_FAILURE:
            return { ...state, deleteComplaintLoading: false, error: action?.message };

        case type.SOCIETY_CHANGE_COMPLAINT_STATUS:
            return { ...state, statusChangeLoading: true, error: null };
        case type.SOCIETY_CHANGE_COMPLAINT_STATUS_SUCCESS:
            return { ...state, statusChangeLoading: false, error: null };
        case type.SOCIETY_CHANGE_COMPLAINT_STATUS_FAILURE:
            return { ...state, statusChangeLoading: false, error: action?.message };

        case type.SOCIETY_ASSIGN_COMPLAINT:
            return { ...state, assignLoading: true, error: null };
        case type.SOCIETY_ASSIGN_COMPLAINT_SUCCESS:
            return { ...state, assignLoading: false, error: null };
        case type.SOCIETY_ASSIGN_COMPLAINT_FAILURE:
            return { ...state, assignLoading: false, error: action?.message };

        case type.SOCIETY_ADD_COMPLAINT_COMMENT:
            return { ...state, commentLoading: true, error: null };
        case type.SOCIETY_ADD_COMPLAINT_COMMENT_SUCCESS:
            return { ...state, commentLoading: false, error: null };
        case type.SOCIETY_ADD_COMPLAINT_COMMENT_FAILURE:
            return { ...state, commentLoading: false, error: action?.message };

        case type.SOCIETY_UPLOAD_COMPLAINT_ATTACHMENTS:
        case type.SOCIETY_DELETE_COMPLAINT_ATTACHMENT:
            return { ...state, attachmentLoading: true, error: null };
        case type.SOCIETY_UPLOAD_COMPLAINT_ATTACHMENTS_SUCCESS:
        case type.SOCIETY_DELETE_COMPLAINT_ATTACHMENT_SUCCESS:
            return { ...state, attachmentLoading: false, error: null };
        case type.SOCIETY_UPLOAD_COMPLAINT_ATTACHMENTS_FAILURE:
        case type.SOCIETY_DELETE_COMPLAINT_ATTACHMENT_FAILURE:
            return { ...state, attachmentLoading: false, error: action?.message };

        case type.SOCIETY_GET_COMPLAINT_ENUMS:
            return { ...state, complaintEnumsLoading: true };
        case type.SOCIETY_GET_COMPLAINT_ENUMS_SUCCESS:
            return { ...state, complaintEnumsLoading: false, complaintEnumsData: action.payload };
        case type.SOCIETY_GET_COMPLAINT_ENUMS_FAILURE:
            return { ...state, complaintEnumsLoading: false, error: action?.message };

        case type.SOCIETY_GET_COMPLAINT_STATS:
            return { ...state, statsLoading: true };
        case type.SOCIETY_GET_COMPLAINT_STATS_SUCCESS:
            return { ...state, statsLoading: false, statsData: action.payload };
        case type.SOCIETY_GET_COMPLAINT_STATS_FAILURE:
            return { ...state, statsLoading: false, error: action?.message };

        case type.SOCIETY_GET_COMPLAINT_CATEGORIES:
            return { ...state, categoriesLoading: true, error: null };
        case type.SOCIETY_GET_COMPLAINT_CATEGORIES_SUCCESS:
            return {
                ...state,
                categoriesLoading: false,
                categoriesData: action.payload?.rows || action.payload?.data || action.payload || [],
            };
        case type.SOCIETY_GET_COMPLAINT_CATEGORIES_FAILURE:
            return { ...state, categoriesLoading: false, error: action?.message };

        case type.SOCIETY_GET_COMPLAINT_CATEGORIES_MULTI:
            return { ...state, categoriesMultiLoading: true, error: null };
        case type.SOCIETY_GET_COMPLAINT_CATEGORIES_MULTI_SUCCESS:
            return {
                ...state,
                categoriesMultiLoading: false,
                categoriesMultiData: Array.isArray(action.payload)
                    ? action.payload
                    : (action.payload?.rows || action.payload?.data || []),
            };
        case type.SOCIETY_GET_COMPLAINT_CATEGORIES_MULTI_FAILURE:
            return { ...state, categoriesMultiLoading: false, error: action?.message };

        case type.SOCIETY_CREATE_COMPLAINT_CATEGORY:
        case type.SOCIETY_UPDATE_COMPLAINT_CATEGORY:
        case type.SOCIETY_DELETE_COMPLAINT_CATEGORY:
            return { ...state, categoryMutationLoading: true, error: null };
        case type.SOCIETY_CREATE_COMPLAINT_CATEGORY_SUCCESS:
        case type.SOCIETY_UPDATE_COMPLAINT_CATEGORY_SUCCESS:
        case type.SOCIETY_DELETE_COMPLAINT_CATEGORY_SUCCESS:
            return { ...state, categoryMutationLoading: false, error: null };
        case type.SOCIETY_CREATE_COMPLAINT_CATEGORY_FAILURE:
        case type.SOCIETY_UPDATE_COMPLAINT_CATEGORY_FAILURE:
        case type.SOCIETY_DELETE_COMPLAINT_CATEGORY_FAILURE:
            return { ...state, categoryMutationLoading: false, error: action?.message };

        case type.SOCIETY_RATE_COMPLAINT:
            return { ...state, ratingLoading: true, error: null };
        case type.SOCIETY_RATE_COMPLAINT_SUCCESS:
            return { ...state, ratingLoading: false, error: null };
        case type.SOCIETY_RATE_COMPLAINT_FAILURE:
            return { ...state, ratingLoading: false, error: action?.message };

        case type.SOCIETY_GET_COMPLAINT_AUDIT_LOG:
            return { ...state, auditLogLoading: true, auditLogData: null, error: null };
        case type.SOCIETY_GET_COMPLAINT_AUDIT_LOG_SUCCESS:
            return {
                ...state,
                auditLogLoading: false,
                auditLogData: action.payload?.rows || action.payload?.data || action.payload || [],
            };
        case type.SOCIETY_GET_COMPLAINT_AUDIT_LOG_FAILURE:
            return { ...state, auditLogLoading: false, error: action?.message };

        case type.SOCIETY_GET_EMPLOYEE_COMPLAINTS:
            return { ...state, employeeComplaintsLoading: true, employeeComplaintsData: null, error: null };
        case type.SOCIETY_GET_EMPLOYEE_COMPLAINTS_SUCCESS:
            return {
                ...state,
                employeeComplaintsLoading: false,
                employeeComplaintsData: action.payload || [],
            };
        case type.SOCIETY_GET_EMPLOYEE_COMPLAINTS_FAILURE:
            return { ...state, employeeComplaintsLoading: false, error: action?.message };

        default:
            return state;
    }
}
